// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"CustomControlPopoverWrapper__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/CustomControl/CustomControlPopoverWrapper.scss
 ** module id = 909
 ** module chunks = 1
 **/